import React, { Component } from 'react'
import { ButtonsBlock, } from 'components/common'
import Button from 'components/UI/Button'
import CMS_REPORT_ENABLED from 'constants'
import {
  handleCloseAllAlerts,
} from 'components/UI/Alert'
import {
  FormWrapper,
  FormTitle,
  FormFooter,
  FormContent,
  FormContainer
} from './styles'


interface Props {
  onPdf: () => void
  onCsv: () => void
  onPrint: () => void
  onBack: () => void
}

//State
interface State {
  isFetchingCreate: boolean
  isFetching: boolean
  error: boolean
}

class CmsForm extends Component<Props, State> {
  render() {
    return (
      <FormWrapper>
        <FormContainer>
          <FormTitle>CMS Price Transparency Report</FormTitle>
         
            <FormContent>
              <br />
            Please note that this estimate is based on historical data over the past 18 months. The actual cost will be based on services actually provided to the patient.<br />
              <br />
            </FormContent>
          
        </FormContainer>
        <FormFooter>
          <ButtonsBlock>
              <Button variant={'default'} onClick={this.onPdf}>
                PDF Format
              </Button>
              <Button variant={'default'} onClick={this.onCsv}>
                CSV Format
             </Button>
             <Button variant={'secondary'} onClick={this.onBack}>
              Back
            </Button>
          </ButtonsBlock>
        </FormFooter>
      </FormWrapper>
    )
  }

  private onPdf = async () => {
    handleCloseAllAlerts()
    this.props.onPdf()
  }

  private onCsv = async () => {
    handleCloseAllAlerts()
    this.props.onCsv()
  }

  private onPrint = async () => {
    handleCloseAllAlerts()
    this.props.onPrint()
  }

  private onBack = async () => {
    handleCloseAllAlerts()
    this.props.onBack()
  }
}

export default CmsForm
